import React from 'react'
import Aimsection from '../views/aboutsection/index'
import Moterializeidea from './aboutsection/Moterializeidea'
function About() {
  return (
    <>
   <Aimsection/>
   <div className='storysection  wow animate__fadeInUp' data-wow-duration="1s">
    <div className='storysection1'>
      <div className='storysection2'>
        <div className='storysectionleft'>

          <div className='storysectionleftcontent'> <h2 className='titlestory'>The story behind us</h2>
          <p className='services_paragraph'>NetAesthetics provides IT solutions to medium and large sized businesses. We are looking for individuals who are passionate about the work they do and enjoy executing on big ideas. We see the world as a playground of endless opportunities for innovation and creative expression.</p>
          </div>
          <div className='storysectionleftimagecon'><img className='storysectionleftimage' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61cb160f0cb36b6bdbe4a2c2_NetAesthetics_About-Us_Photo-B.jpg" alt="" /></div>
        </div>
        <div className='storysectionright'>

          <div className='storysectionrightimagecon'> <img className='storysectionrightimage' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61cb1613f08b9f4cbb0f820b_NetAesthetics_About-Us_Photo-A.jpg" alt="" /></div>
          <div className='storysectionrightcontent'> 
            <h2 className='titlestory'>The mission behind all our work</h2>
            <p className='services_paragraph'>Our goal is to empower your company with the tools and education to grow, we're in it for the long haul. We envision a future where the knowledge and technology powering society is universally accessible and freely used. Join us as we connect the world, create opportunity and make lives better.</p>
          </div>
        </div>
      </div>
    </div>
   </div>
   <Moterializeidea/>
   </>
  )
}

export default About